import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["src"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Icon = _resolveComponent("Icon")

  return ($data.failed)
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        ($props.failedIcon)
          ? (_openBlock(), _createBlock(_component_Icon, {
              key: 0,
              icon: "cube-02",
              width: $props.size,
              height: $props.size,
              "stroke-width": "var(--icon-stroke-width)",
              stroke: "var(--gray-500)"
            }, null, 8 /* PROPS */, ["width", "height"]))
          : _createCommentVNode("v-if", true)
      ], 64 /* STABLE_FRAGMENT */))
    : (_openBlock(), _createElementBlock("img", {
        key: 1,
        src: $props.src,
        style: _normalizeStyle({width: $props.size, heigth: $props.size}),
        onError: _cache[0] || (_cache[0] = (...args) => ($options.onFail && $options.onFail(...args)))
      }, null, 44 /* STYLE, PROPS, NEED_HYDRATION */, _hoisted_1))
}